import React, { useState } from 'react';  // Make sure React and useState are imported
import { LanguageProvider } from '../context/LanguageContext';
import { NavigationProvider } from '../context/NavigationContext';
import { Header } from './Header';
import { Footer } from './Footer';
import { Home } from './Home';
import { Features } from './Features';
import { Detector } from './Detector';
import { Privacy } from './Privacy';
import { Contact } from './Contact';
import { Focus } from './Focus';
import { CookieConsent } from './CookieConsent';
import { ApplicationModal } from './ApplicationModal';
import { useNavigation } from '../hooks/useNavigation';
import { useLanguage } from '../hooks/useLanguage';
import '../styles/global.css';

// Main app content with hooks
const AppContent = () => {
  const { currentPage } = useNavigation();
  const { language, setLanguage } = useLanguage();
  const [showModal, setShowModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState('');

  const openModal = (plan) => {
    setSelectedPlan(plan);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const renderContent = () => {
    switch (currentPage) {
      case 'home':
        return <Home />;
      case 'features':
        return <Features />;
      case 'detector':
        return <Detector />;
      case 'privacy':
        return <Privacy />;
      case 'contact':
        return <Contact />;
      case 'focus':
        return <Focus />;
      default:
        return <Home />;
    }
  };

  return (
    <div className="app">
      <Header 
        language={language} 
        setLanguage={setLanguage} 
      />
      
      <main className="main-content">
        {renderContent()}
      </main>
      
      <Footer />
      <CookieConsent />
      
      {showModal && (
        <ApplicationModal 
          selectedPlan={selectedPlan} 
          closeModal={closeModal} 
        />
      )}
    </div>
  );
};

// Root App with providers
export const App = () => {
  return (
    <LanguageProvider>
      <NavigationProvider>
        <AppContent />
      </NavigationProvider>
    </LanguageProvider>
  );
};